// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 592 ? "c15bf2b0" : chunkId) + "-" + {"415":"5bfbc02d6b27e642","478":"a9f9ff6515ea29fe","592":"13eceae305ec43cc"}[chunkId] + ".js";
};